import React from 'react';
import * as Icons from 'react-feather';

const IconRender = ({ iconName = 'Book', ...props }) => {
  const Icon = Icons[iconName];
  return <Icon {...props} />;
};

export default IconRender;
